var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.exibirAlerta)?_c('div',{staticClass:"alert text-center",class:[_vm.classe],attrs:{"id":"alerta-plano"}},[_vm._v(" "+_vm._s(_vm.mensagem)+" "),_c('a',{staticClass:"ml-2 btn btn-success",attrs:{"href":_vm.linkBotao}},[_vm._v(" "+_vm._s(_vm.mensagemBotao)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }